import {createAction, props} from '@ngrx/store';
import {Experience} from '@cemex-core/cmx-api';


export const fetch = createAction(
  '[MOO/MODAL/Experience] Fetch start',
);

export const fetchSuccess = createAction(
  '[MOO/MODAL/Experience] Fetch success',
  props<{ payload: Experience[] }>(),
);

export const fetchFailed = createAction(
  '[MOO/MODAL/Experience] Fetch failed',
);

export const resetExperiencesState = createAction(
  '[MOO/MODAL/Experience] Reset State',
);

const ExperiencesActions = {

  fetch,
  fetchSuccess,
  fetchFailed,

  resetExperiencesState,
};

export default ExperiencesActions;
